import { render, staticRenderFns } from "./CreateModule.vue?vue&type=template&id=6ec3c13e&"
import script from "./CreateModule.vue?vue&type=script&lang=js&"
export * from "./CreateModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports